<h1 mat-dialog-title>{{campaign ? ('Editing Campaign "' + campaign.campaignName + '"') : 'Add Campaign'}}</h1>
@if (campaign) {
  <h4>{{campaign.id}}</h4>
}

<form [formGroup]="form" class="form">
  <mat-form-field appearance="outline">
    <mat-label>Name</mat-label>
    <input matInput formControlName="campaignName">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Brand</mat-label>
    <mat-select formControlName="brandId">
      @for (brand of brands; track brand) {
        <mat-option [value]="brand.id">{{brand.name}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="dates">
    <mat-form-field appearance="outline">
      <mat-label>Start Date</mat-label>
      <input matInput type="date" formControlName="startAt">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput type="date" formControlName="endAt">
    </mat-form-field>
  </div>

  <div class="balances">
    <mat-form-field appearance="outline">
      <mat-label>Starting Balance</mat-label>
      <input matInput formControlName="startingBalance">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Current Balance</mat-label>
      <input matInput formControlName="currentBalance">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Low Balance</mat-label>
      <input matInput formControlName="lowBalance">
    </mat-form-field>
  </div>

  <app-offer-audiences [control]="form.controls.rules"></app-offer-audiences>
  <mat-form-field appearance="outline" class="json-field">
    <mat-label>Rules JSON</mat-label>
    <app-json formControlName="rules" baseTable="rewardsCampaigns" fieldHint="rules"></app-json>
  </mat-form-field>

  <div class="buttons" mat-dialog-actions>
    <button mat-raised-button color="primary" [disabled]="form.invalid || saving" (click)="save()">Save</button>
    @if (campaign) {
      <button mat-stroked-button color="warn" (click)="delete()">Delete</button>
    }
    <button mat-button (click)="cancel()">Cancel</button>
  </div>
</form>
